module.exports = __webpack_public_path__ + "img/130-Gris Basalte SFTN Mat.jpg";